export const environment: {
	production: boolean;
	deployUrl?: string;
} = {
	production: true,
	deployUrl: '/Assets/pluto',
};
